const firebaseConfig = {
    apiKey: "AIzaSyCJ7aqEYq3FQkplrDOfJg7LxAEvoSXNaCw",
    authDomain: "maiden-tourism.firebaseapp.com",
    projectId: "maiden-tourism",
    storageBucket: "maiden-tourism.appspot.com",
    messagingSenderId: "1097618740871",
    appId: "1:1097618740871:web:9baa0b3d01e83617d40a22"
  };

export default firebaseConfig;